export const autoHideMessage =
  'You selected to automatically hide media when the listing goes Off Market. Please select the main exterior photo to keep publicly visible by editing the photo and clicking "Keep When Closed."';
